import { render, staticRenderFns } from "./SalesPayer.vue?vue&type=template&id=927dcb58&"
import script from "./SalesPayer.vue?vue&type=script&lang=js&"
export * from "./SalesPayer.vue?vue&type=script&lang=js&"
import style0 from "./SalesPayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports